const TOKEN_KEY = 'auth_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

// Global promise to track ongoing refresh requests
let refreshTokenPromise = null;

export const tokenManager = {
  getToken: () => {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  setToken: (token) => {
    sessionStorage.setItem(TOKEN_KEY, token);
  },

  getRefreshToken: () => {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  },

  setRefreshToken: (refreshToken) => {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  clearTokens: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    refreshTokenPromise = null; // Reset the promise when clearing tokens
  },

  isTokenValid: () => {
    const token = tokenManager.getToken();
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp > currentTime;
    } catch (error) {
      return false;
    }
  },

  // Get or set the refresh token promise to ensure only one refresh happens at a time
  getRefreshPromise: () => refreshTokenPromise,
  
  setRefreshPromise: (promise) => {
    refreshTokenPromise = promise;
  },
  
  clearRefreshPromise: () => {
    refreshTokenPromise = null;
  },
};
